module.exports = new __parcel__URL__("list-merge-spotlight-light.b81dbbfb.gif").toString();